module.exports = {
  /* eslint-disable */
  githubSrc: 'https://raw.githubusercontent.com/mentalwellbeing/screening/master/protocol/MentalWellBeingScreening_schema',
  banner: 'This is a screening protocol for Mental Health Wellbeing study.',
  startButton: 'Join',
  assetsPublicPath: '/screening/',
  backendServer: null
};



// WEBPACK FOOTER //
// ./src/config.js